/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type TeamSettingsSearch_team = {
    readonly id: string;
    readonly teamId: string;
    readonly teamName: string;
    readonly createdBy: {
        readonly type: UrnType | null;
        readonly value: string | null;
    };
    readonly teamMembers: ReadonlyArray<{
        readonly role: TeamMemberRole;
        readonly person: {
            readonly __typename: string;
            readonly calendarAliases: ReadonlyArray<string>;
            readonly redirectPersonId: string | null;
            readonly id: string;
            readonly primaryCalendarId: string;
            readonly isYou: boolean;
            readonly userId: string | null;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
        };
    }>;
    readonly invitedMembers: ReadonlyArray<{
        readonly role: TeamMemberRole;
        readonly person: {
            readonly __typename: string;
            readonly calendarAliases: ReadonlyArray<string>;
            readonly redirectPersonId: string | null;
            readonly id: string;
            readonly primaryCalendarId: string;
            readonly isYou: boolean;
            readonly userId: string | null;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
        };
    }>;
    readonly " $refType": "TeamSettingsSearch_team";
};
export type TeamSettingsSearch_team$data = TeamSettingsSearch_team;
export type TeamSettingsSearch_team$key = {
    readonly " $data"?: TeamSettingsSearch_team$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsSearch_team">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarAliases",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "redirectPersonId",
                    "storageKey": null
                },
                (v0 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isYou",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalImageUrl",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "TeamSettingsSearch_team",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamId",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Urn",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMembers",
                "plural": true,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "invitedMembers",
                "plural": true,
                "selections": (v1 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "Team",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '6b5d772bc11c9cb7d4d42291c37aadf8';
export default node;
